var map = {
	"./OCR-icon-h.svg": "TQXe",
	"./OCR-icon.svg": "A7rW",
	"./aiAnswer-icon-h.svg": "5Jo7",
	"./aiAnswer-icon.svg": "JDCT",
	"./bankIdentify-icon-h.svg": "wARP",
	"./bankIdentify-icon.svg": "oGls",
	"./bankReceipt-icon-h.svg": "aBqx",
	"./bankReceipt-icon.svg": "3uSL",
	"./blockChain-icon-h.svg": "QI9G",
	"./blockChain-icon.svg": "qH7A",
	"./costIdentify-icon-h.svg": "SPzj",
	"./costIdentify-icon.svg": "kcfO",
	"./creditInquiry-icon-h.svg": "Ie+L",
	"./creditInquiry-icon.svg": "Rknc",
	"./cusService-icon-h.svg": "dK/D",
	"./cusService-icon.svg": "VNqY",
	"./declare-icon-h.svg": "AwrQ",
	"./declare-icon.svg": "5NRS",
	"./deduct-icon-h.svg": "yT2d",
	"./deduct-icon.svg": "IEYf",
	"./fileSave-icon-h.svg": "9doC",
	"./fileSave-icon.svg": "FRQb",
	"./flow-icon-h.svg": "H9S3",
	"./flow-icon.svg": "wqmk",
	"./format-icon-h.svg": "0ifD",
	"./format-icon.svg": "qbBd",
	"./funds-icon-h.svg": "u8uJ",
	"./funds-icon.svg": "7q77",
	"./invoiceCheck-icon-h.svg": "THoe",
	"./invoiceCheck-icon.svg": "1LbI",
	"./invoiceCollection-icon-h.svg": "pNkA",
	"./invoiceCollection-icon.svg": "EEmn",
	"./invoiceCtrl-icon-h.svg": "XJ11",
	"./invoiceCtrl-icon.svg": "iPvc",
	"./invoiceIdentify-icon-h.svg": "8Mxh",
	"./invoiceIdentify-icon.svg": "NRDE",
	"./markService-icon-h.svg": "VgLe",
	"./markService-icon.svg": "lWYK",
	"./more.svg": "PdAv",
	"./order-icon-h.svg": "vQ1q",
	"./order-icon.svg": "9RSv",
	"./receipt-icon-h.svg": "krsV",
	"./receipt-icon.svg": "B8TP",
	"./riskControl-icon-h.svg": "Po43",
	"./riskControl-icon.svg": "Tccr",
	"./riskCtrl-icon-h.svg": "nqkK",
	"./riskCtrl-icon.svg": "ojXH",
	"./scene-icon-h.svg": "yj9l",
	"./scene-icon.svg": "Uyob",
	"./signature-icon-h.svg": "tolR",
	"./signature-icon.svg": "v1+3",
	"./small-taxpayer-icon-h.svg": "RRhH",
	"./small-taxpayer-icon.svg": "o2aH",
	"./smart-accounting-icon-h.svg": "5VtU",
	"./smart-accounting-icon.svg": "6JCW",
	"./success.svg": "qM/a",
	"./tax-icon-h.svg": "zX3F",
	"./tax-icon.svg": "xtEe",
	"./taxCtrl-icon-h.svg": "Wy15",
	"./taxCtrl-icon.svg": "SdZk",
	"./taxCtrlplugin-icon-h.svg": "SPC/",
	"./taxCtrlplugin-icon.svg": "nTWn",
	"./taxDeclare-icon-h.svg": "DGtA",
	"./taxDeclare-icon.svg": "JJ3w",
	"./taxWarn-icon-h.svg": "0GxC",
	"./taxWarn-icon.svg": "yI8j",
	"./taxpayer-icon-h.svg": "hjj9",
	"./taxpayer-icon.svg": "dCp2",
	"./titileInquiry-icon-h.svg": "fhL9",
	"./titileInquiry-icon.svg": "ZQkA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";